import React from "react";
import RoomOverridesSection from "./RoomOverridesSection.jsx";
import TrainerLeavesSection from "./TrainerLeavesSection.jsx";
/* The page kit, in place of the classroom app's own cls-* vocabulary --
   see LabsTab for the full note. */
import "../../../../components/Trainer/TrainerDashboard.css";
import "../../../../components/common/lms-pages.css";

/* Two lists on one page, each with its own heading and its own action.
   The page says what the pair is for; each section then says which half
   of it you are looking at.

   .pg is a 16px flex column, so nesting one per section is what spaces
   them -- the old file used an inline `marginBottom: 28` on the first
   one instead. */
const ShiftsOverridesTab = () => (
  <div className="pg">
    <header className="pg-head">
      <div className="pg-head-main">
        <h1 className="pg-title">Shifts &amp; overrides</h1>
        <p className="pg-sub">
          One-day departures from the timetable: a batch moved or called off,
          and a trainer away.
        </p>
      </div>
    </header>

    <RoomOverridesSection />
    <TrainerLeavesSection />
  </div>
);

export default ShiftsOverridesTab;
